module.exports = __webpack_public_path__ + "img/stick-on.ae79352a.jpg";